export default {
    upload: '/common/upload', // 上传图片
    typeList: '/common/type/list', // 获取身份类型
    baseInfo: '/admin/config/get', // 基础配置
    setConfig: '/admin/config/set', // 基础配置
    picbase64: '/common/picbase64', // 获取图片base64
    getArea: '/common/address/area', // 获取省、市、区
    getCode: '/common/wx/mini/code', // 生成微信小程序码
    sendSms: '/common/send/sms/code',

    // 登录
    manageLogin: '/admin/rule/user/login', // 登录

    setOption: '/admin/conf/batch/set', // 批量配置参数
    getOption: '/admin/conf/batch/get', // 批量读取配置参数


    // 参数配置
    getCongfigList: '/admin/conf/list',
    getCongfigGroupList: '/admin/conf/group/list',
    setConfig: '/admin/conf/batch/set',
    deleteConfig: '/admin/conf/delete',

    managerLogout: '/admin/rule/user/logout',
    getCaptchaImg: '/common/captcha', // 获取登录图片验证码

    uploadPay: '/admin/pay/merchant/info/upload',

    // 账号管理
    managerList: '/admin/admin/user/list', // 管理员列表
    addManager: '/admin/admin/user/add', // 添加管理员
    editManager: '/admin/admin/user/modify', // 修改管理员信息
    editPassword: '/admin/admin/user/password', // 修改管理员密码
    editManagerStatus: '/admin/admin/user/status', // 管理员状态更改

    // 权限管理
    powerGroupList: '/admin/admin/group/list', // 权限组列表
    deletePowerGroup: '/admin/admin/group/delete', // 删除权限组
    powerList: '/admin/admin/acl/list', // 所有权限列表
    choiceGroupPower: '/admin/admin/group/acls', // 权限组所属权限列表
    editGroupPower: '/admin/admin/group/acl', // 权限组权限修改
    powerGroupMember: '/admin/admin/group/users', // 权限组成员列表
    choiceManagerGroup: '/admin/admin/user/groups', // 管理员所属组列表
    editManagerGroup: '/admin/admin/user/group', // 管理员所属组修改列表

    // 菜单维护
    menuList: '/admin/rule/menu/list', // 菜单列表
    addMenu: '/admin/rule/menu/add', // 菜单添加
    editMenu: '/admin/rule/menu/edit', // 菜单编辑
    deleteMenu: '/admin/rule/menu/delete', // 菜单删除
    managerMenu: '/admin/rule/permission/menu/available/list', // 有权限的菜单列表(根据登录的管理员获取的菜单列表)



    //----------------------------------- 组织架构 --------------------------------------------------------

    getOrgStructList: '/admin/org/struct/list',
    updateOrgStruct: '/admin/org/struct/edit',
    deleteOrgStruct: '/admin/org/struct/delete',
    addOrgStruct: '/admin/org/struct/add',
    bindingSuperior: '/admin/user/binding/superior',




    addMember: '/admin/rule/user/add',
    updateMember: '/admin/rule/user/edit',
    getMemberList: '/admin/rule/user/list',
    getGroupListByUser: '/admin/rule/permission/user/group/list',
    freezeUser: '/admin/rule/user/freeze',
    unfreezeUser: '/admin/rule/user/unfreeze',



    // 合作伙伴
    getPartnerList: '/admin/partner/list',
    getPartnerInfo: '/admin/partner/info',
    addPartner: '/admin/partner/create',
    updatePartner: '/admin/partner/update',



    //权限组
    getGroupList: '/admin/rule/permission/group/list',
    addGroup: '/admin/rule/permission/add/group',
    deleteGroup: '/admin/rule/permission/delete/group',
    bindGroup: '/admin/rule/permission/link/user',

    getPermissionMenuList: '/admin/rule/permission/menu/optional/list',
    updatePermissionMenu: '/admin/rule/permission/menu/link',
    getPermissionApiList: '/admin/rule/permission/api/optional/list',
    updatePermissionApi: '/admin/rule/permission/api/link',

    //api管理
    getApiList: '/admin/rule/api/list',
    addApi: '/admin/rule/api/add',
    deleteApi: '/admin/rule/api/delete',
    updateApi: '/admin/rule/api/edit',
    readApi: '/admin/rule/api/read',



    //字典
    getDictionaryList: '/admin/dictionary/list',
    addDictionary: '/admin/dictionary/create',
    deleteDictionary: '/admin/dictionary/delete',
    updateDictionary: '/admin/dictionary/update',
    lockDictionary: '/admin/dictionary/lock',

    //字典项
    addDictionaryItem: '/admin/dictionary/item/create',
    getDictionaryItem: '/admin/dictionary/info',
    deleteDictionaryItem: '/admin/dictionary/item/delete',
    updateDictionaryItem: '/admin/dictionary/item/update',
    lockDictionaryItem: '/admin/dictionary/item/lock',
    getDictionaryByName: '/admin/dictionary/item/list/son',



    //轮播图
    getBannerList: '/admin/setup/banner/list', // 轮播图列表
    addBanner: '/admin/setup/banner/add', // 添加轮播图
    updateBanner: '/admin/setup/banner/update', // 编辑轮播图
    deleteBanner: '/admin/setup/banner/delete', // 删除轮播图


    //标签
    getLabelList: '/admin/label/list',
    addLabel: '/admin/label/create',
    deleteLabel: '/admin/label/delete',
    updateLabel: '/admin/label/update',
    lockLabel: '/admin/label/lock',
    changeLabelFilter: '/admin/label/filter',
    getFilterLabel: '/admin/label/filter',

    //标签项
    addLabelItem: '/admin/label/item/create',
    getLabelItem: '/admin/label/info',
    deleteLabelItem: '/admin/label/item/delete',
    updateLabelItem: '/admin/label/item/update',
    lockLabelItem: '/admin/label/item/lock',
    getLabelByName: '/admin/label/item/list/son',
    changeLabelItemFilter: '/admin/label/item/filter',
    changeLabelItemRecommend: '/admin/label/item/recommend',

    
    // 协议
    updateAgreement: '/admin/agreement/update',
    getAgreementInfo: '/admin/agreement/info',
    getAgreementList: '/admin/agreement/list',
    addAgreement: '/admin/agreement/add',

    //公众号
    getPublicCodeInfo: '/admin/public/code/info',
    updatePublicCode: '/admin/public/code/update',

    // 分享设置
    getShareInfo: '/admin/setup/share/info', // 分享详情
    updateShare: '/admin/setup/share/update', // 修改分享


    // 品牌
    getBrandList: '/admin/brand/set/list',
    addBrand: '/admin/brand/set/add',
    updateBrand: '/admin/brand/set/update',
    deleteBrand: '/admin/brand/set/delete',
    getBrandInfo: '/admin/brand/set/info',
    changeBrandHot: '/admin/brand/set/update/hot',
    //系列
    getSeriesList: '/admin/brand/set/series/list',
    addSeries: '/admin/brand/set/series/add',
    deleteSeries: '/admin/brand/set/series/delete',


    // 文章 评测
    // 轮播图
    getPlatformBannerList: '/admin/platform/banner/list',
    updatePlatformBanner: '/admin/platform/banner/update',
    addPlatformBanner: '/admin/platform/banner/add',
    deletePlatformBanner: '/admin/platform/banner/delete',


    //分类
    getPlatformCategoryList: '/admin/platform/classify/list',
    addPlatformCategory: '/admin/platform/classify/add',
    updatePlatformCategory: '/admin/platform/classify/update',
    deletePlatformCategory: '/admin/platform/classify/delete',
    getPlatformCategoryInfo: '/admin/platform/classify/info',

    // 文章
    getPlatformArticleList: '/admin/platform/article/list',
    addPlatformArticle: '/admin/platform/article/add',
    updatePlatformArticle: '/admin/platform/article/update',
    deletePlatformArticle: '/admin/platform/article/delete',
    getPlatformArticleInfo: '/admin/platform/article/info',

    getProductInfo: '/admin/platform/article/product/info',

    // 用户管理
    getUserList: '/admin/user/list',
    getUserInfo: '/admin/user/info',
    getFamilyList: '/admin/baby/family',
    getFamilyInfo: '/admin/user/family/info',
    getBabyList: '/admin/user/baby/list',
    getBabyRecord: '/admin/user/baby/record/list',

    getFamilyListByUid: '/admin/user/family/list',
    getBabyListByUid: '/admin/user/baby/list',
    getBabyRecordList: '/admin/user/baby/record/list',

    

    //意见反馈
    getFeedbackList: '/admin/feedback/list',
    getFeedbackInfo: '/admin/feedback/info',

    //平台咨询次数
    getPlatformConsultList: '/admin/platform/consult/list',


    // 资金
    getBalanceList: '/admin/fund/balance/list',
    getPayBillList: '/admin/fund/pay/bill/list',
    getFundTypeMap: '/admin/fund/type/map',

    //产品管理
    addGood: '/admin/goods/add',
    updateGood: '/admin/goods/edit',
    deleteGood: '/admin/goods/delete',
    copyGood: '/admin/goods/copy',
    getGoodsList: '/admin/goods/list',
    getGoodInfo: '/admin/goods/info',
    updateGoodTwig: '/admin/goods/set/twig',
    // updateGoodStatus: '/admin/goods/set/status',
    setHotGood: '/admin/goods/set/hot',

    // 商品上架下架
    updateGoodStatus: '/admin/goods/set/status',

    // 用户画像
    getPortraitList: '/admin/portrait/group/list',
    addPortraitFirstLabel: '/admin/portrait/first/group/add',
    deletePortraitFirstLabel: '/admin/portrait/first/group/delete',
    addPortraitSecondLabel: '/admin/portrait/second/group/add',
    deletePortraitSecondLabel: '/admin/portrait/second/group/delete',
    addPortraitBehavior: '/admin/portrait/behavior/add',
    getPortraitSecondLabelInfo: '/admin/portrait/second/group/info',
    getPortraitBehaviorList: '/admin/portrait/behavior/condition/list',
    getUserListByPortrait: '/admin/portrait/user/portrait/list',

    getPortraitByUid: '/admin/portrait/user/info/portrait/list',



    // 首页
    getIndexData: '/admin/home/index',
    getIndexBrandData: '/admin/home/brand',
    getIndexProductClick: '/admin/home/product/click',
    getIndexProductConsult: '/admin/home/product/consult',
    getIndexBalance: '/admin/home/day/balance',

    getPortraitByBrand: '/admin/portrait/brand/list',
    getPortraitByProduct: '/admin/portrait/product/list',
    getPortraitByBanner: '/admin/portrait/banner/list',


    getHotspotList: '/admin/portrait/hotspot/list',


    // 高级搜索
    getPortraitSearchList: '/admin/portrait/advanced/search/list',
    addPortraitSearch: '/admin/portrait/advanced/search',
    updatePortraitSearch: '/admin/portrait/advanced/search/update',
    getPortraitSearchInfo: '/admin/portrait/advanced/search/info',
    deletePortraitSearch: '/admin/portrait/advanced/search/delete',
    getPortraitSearchResult: '/admin/portrait/advanced/search/result',

    getPortraitSearchName: '/admin/portrait/brand/name/list',
    getPortraitSearchResult: '/admin/portrait/advanced/search/result',



    portraitClickList: '/admin/portrait/click/list',

    getServicerList: '/admin/platform/consult/servicer/list',
    addServicer: '/admin/platform/consult/servicer/add',
    deleteServicer: '/admin/platform/consult/servicer/del',


    getChatListByUid: '/admin/chat/list',
    getChatInfo: '/admin/chat/info',
    getChatMsgList: '/admin/chat/msg/list',



    getFreightList: '/admin/freight/list', // 运费模板列表
    getFreightInfo: '/admin/freight/info', // 运费模板详情
    addFreight: '/admin/freight/add', // 创建运费模板
    updateFreight: '/admin/freight/update', // 编辑运费模板
    deleteFreight: '/admin/freight/delete',

    getNoDeliver: '/admin/deliver/info', // 不发货地区详情
    setNoDeliver: '/admin/deliver/update', // 编辑不发货地区
    getAreaName: '/admin/freight/name/list',


    //样品管理
    addSample: '/admin/goods/add/sample',
    updateSample: '/admin/goods/edit/sample',
    deleteSample: '/admin/goods/delete/sample',
    getSampleList: '/admin/goods/sample/list',
    getSampleInfo: '/admin/goods/sample/info',



    // 订单
    orderList: '/admin/order/list', // 订单列表
    orderDetail: '/admin/order/info', // 订单详情
    afterList: '/admin/after/sale/list', // 售后列表
    afterDetail: '/admin/after/sale/info', // 售后详情
    afterExamine: '/admin/after/sale/examine', // 订单审核
    importOrder: '/admin/order/delivery', // 订单导入


    // 售后
    getAfterSaleList: '/admin/order/after/sale/list',
    getAfterSaleList2: '/admin/order/after/sale/service/list',
    getAfterSaleFinancialList: '/admin/order/after/sale/financial/list',
    agreeAfterSale: '/admin/order/after/sale/service/agree',
    rejectAfterSale: '/admin/order/after/sale/service/reject',
    afterSaleInfo: '/admin/order/after/sale/info',
    agreeAfterSale2: '/admin/order/after/sale/agree/refund',
    rejectAfterSale2: '/admin/order/after/sale/financial/reject',
    changeAfterSaleAmount: '/admin/order/after/sale/change/amount',
    sendHistory: '/admin/order/after/sale/send/history',


    updateBalance: '/admin/user/balance/update',
    

    addLive: '/admin/live/add',
    deleteLive: '/admin/live/del',
    updateLiveStatus: '/admin/live/update/status',
    getLiveList: '/admin/live/list',


    exportGoods: '/admin/goods/export',



    uploadExcel: '/admin/goods/import',



    //预设问题
    getSeedQuestionList: '/admin/chat/seed/question/list',
    addSeedQuestion: '/admin/chat/seed/question/create',
    deleteSeedQuestion: '/admin/chat/seed/question/del',
    updateSeedQuestion: '/admin/chat/seed/question/update',
    updateSeedQuestionShow: '/admin/chat/seed/question/set/is/show',


    uploadDiagnostic: '/admin/diagnostic/upload',

    updateDiagnosticProduct: '/admin/diagnostic/update/product/info',

};